import React from 'react'
import styled from 'styled-components'
import {explainers} from './content'

Features = (props)->
	<div>
		{explainers.map ({title, body, note, imageWidth, contentWidth}, i)->
			number = i+1
			<Feature key={number}>
			<Innerwrap>
				<Content contentWidth={contentWidth}>
					<SubTitle>{"Feature ##{number}"}</SubTitle>
					<Title>{title}</Title>
					<Body dangerouslySetInnerHTML={__html:body}></Body>
					{if note
						<Note>{note}</Note>
					}
				</Content>
				<Illustration src="/files/img/feature-explainers/illustration-#{number}@2x.png" imageWidth={imageWidth} />
			</Innerwrap>
			</Feature>
		}
	</div>


Feature = styled.div"""
	box-sizing: border-box
	border-top: 1px solid #DBDDE0;
	padding: 70px 0;
	
	&:first-child {
		border-top: 0
	}

"""

Innerwrap = styled.div"""
	box-sizing: border-box
	display: flex
	align-items: center
	justify-content: space-between
	width: 100%
	max-width: 1170px
	margin: 0 auto;
	padding: 0 20px;
	z-index: 2

	@media(max-width:736px) {
		flex-direction: column
	}
"""

Content = styled.div"""
	width: 56%
	max-width: #{({contentWidth})-> contentWidth or 485}px
	flex-shrink: 0
	flex-grow: 0
	margin-right: 35px
	font-family: din

	@media(max-width:736px) {
		order: 2
		width: 100%
		max-width: none
		margin-right: 0
		margin-top: 43px
		text-align: center
	}
"""

SubTitle = styled.div"""
	font-size: 33px
	font-weight: 600
	color: #5d5d5d
	opacity: 0.29
	text-transform: uppercase

	@media(max-width:900px) {
		font-size: 30px
	}
"""

Title = styled.div"""
	margin-top: 14px
	font-size: 43px
	font-weight: 600
	line-height: 1.33em
	text-transform: uppercase

	@media(max-width:900px) {
		margin-top: 11px
		font-size: 41px
	}
"""

Body = styled.div"""
	max-width: 431px
	margin-top: 24px
	font-size: 22px
	font-weight: 400
	line-height: 1.43em

	@media(max-width:900px) {
		margin-top: 21px
		font-size: 21px
	}
	@media(max-width:736px) {
		margin: 21px auto 0;
	}
"""

Note = styled.div"""
	max-width: 431px
	margin-top: 10px
	font-size: 14px
	font-weight: 400
	line-height: 1.43em
	opacity: 0.65
"""

Illustration = styled.img"""
	display: block
	width: 41%
	max-width: #{({imageWidth})-> imageWidth or 380}px
	flex-shrink: 1

	@media(max-width:736px) {
		order: 1
		width: 90%
		margin: 0 auto;
	}
"""


export default Features